import { Pergunta } from 'api/DuvidasFrequentes';
import { ConfirmedPresenceNotOnline } from 'components/Modal/ConfirmedPresenceNotOnline/ConfirmedPresenceNotOnline';
import SeletorContasParaVotoModal from 'components/Modal/SeletorContasParaVotoModal/SeletorContasParaVotoModal';
import UnanticipatedUser from 'components/Modal/UnanticipatedUser';
import Loading from 'components/Modal/__LEGACY__/AbrirVotacaoPautaModal/Loading';
import AssembleiaDocsModal, {
  IAssembleiaDocsModalGenericProps,
} from 'components/Modal/__LEGACY__/AssembleiaDocsModal/AssembleiaDocsModal';
import AssembleiaVideosModal, {
  IAssembleiaVideosModalGenericProps,
} from 'components/Modal/__LEGACY__/AssembleiaVideosModal/AssembleiaVideosModal';
import { ApiErrors } from 'helpers/enums/ApiErrors';
import { AssemblyModalities } from 'helpers/enums/Assembleia';
import { AssembleiaStatus } from 'helpers/enums/AssembleiaStatus';
import { AssembleiaTipo } from 'helpers/enums/AssembleiaTipo';
import { FlagColaborador } from 'helpers/enums/TipoColaborador';
import {
  contaSelecionadaPeloUsuario,
  getTotalContasSelecionadasOuNaoPeloUsuario,
  getTotalContasSelecionadasPeloUsuario,
} from 'helpers/utils/AssembleiaUtils';
import ErrorHandler from 'helpers/utils/ErrorHandler';
import { getUniqueKey } from 'helpers/utils/KeyUtils';
import { AssociadoRoutePath } from 'library/Routes';
import translation from 'locales/translation';
import UnauthorizedScreen from 'pages/Errors/UnauthorizedScreen/UnauthorizedScreen';
import { Row, ToastTypes } from 'plataforma-fundacao-componentes';
import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useReducer,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import {
  assembleiaAssociadoActionsLoadDuvidas,
  assembleiaAssociadoActionsLoadEvent,
  assembleiasAssociadoActionsCheckVotePermission,
  assembleiasAssociadoActionsLoadContas,
  assembleiasAssociadoActionsLoadPautas,
} from 'store/modules/AssembleiasAssociadoActions';
import { ASSEMBLEIAS_ASSOCIADO_UPDATE_VOTE_PERMISSION } from 'store/modules/AssembleiasAssociadoActionTypes';
import {
  IAssembleiaContaAssociado,
  IAssembleiasAssociadoReducer,
} from 'store/modules/AssembleiasAssociadoReducer';
import { closeModal, openModal } from 'store/modules/ModalActions';
import { modalsActionsOpen } from 'store/modules/ModalsActions';
import {
  wsAssembleiasActionsClose,
  wsAssembleiasActionsOpen,
} from 'store/modules/WSAssembleiasActions';
import { IWSAssembleiasReducer } from 'store/modules/WSAssembleiasReducer';
import { IReducer } from 'store/Reducer';
import Assembleia from './Assembleia';
import Context from './Context';
import Pautas from './Pautas';
import PreAssembleia from './PreAssembleia';
import { duvidasInitialState, duvidasReducer } from './reducer';
import style from './styles.module.scss';
import { AxiosError } from 'axios';
import { ErrorApi } from 'api/interfaces';
import LayoutContext from 'components/Layout/LayoutContext';
import { languageValues } from 'helpers/utils/languageUtils';
import eventoAPI from 'api/EventoAssociado/evento';

interface RouteParams {
  id: string;
}

const selecaoContasModalKey = getUniqueKey();
const ContasConfirmadasModalKey = getUniqueKey();

export default function AssembleiaAssociado() {
  const { id } = useParams<RouteParams>();
  const [firstSelection, setFirstSelection] = useState<boolean>(false);

  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const { currentEvent, loadingEvent, loadingPautas, loadingContas } =
    useSelector((state: IReducer) => state.assembleias);

  const { usuario } = useSelector((state: IReducer) => state.auth);

  const { opened: wsOpened } = useSelector((state: IReducer) => {
    return state.wsAssembleias;
  });

  const { assembleiasChanges } = useSelector<IReducer, IWSAssembleiasReducer>(
    (state) => state.wsAssembleias
  );
  const { duvidas } = useSelector<IReducer, IAssembleiasAssociadoReducer>(
    (state) => state.assembleias
  );
  const [{ perguntas, message, idEvento: idEventoReducer }, action] =
    useReducer(duvidasReducer, duvidasInitialState);

  const { showToast } = useContext(LayoutContext);

  const permissionLive = useMemo(
    () =>
      currentEvent &&
      currentEvent.status >= AssembleiaStatus.Live &&
      usuario?.perfil.associadoRoute.assembleias.live.ver,
    [currentEvent, usuario?.perfil.associadoRoute.assembleias.live.ver]
  );

  const permissionPre = useMemo(
    () =>
      currentEvent &&
      (currentEvent.modoEvento === AssemblyModalities.OFFLINE ||
        (currentEvent.status === AssembleiaStatus.Pre &&
          usuario?.perfil.associadoRoute.assembleias.pre.ver) ||
        (currentEvent?.modoEvento ===
          AssemblyModalities.HIBRIDO_PRESENCIAL_DIGITAL &&
          currentEvent?.status === 0)),
    [currentEvent, usuario?.perfil.associadoRoute.assembleias.pre.ver]
  );

  const atualizarPergunta = useCallback(
    (changes: Pergunta, flgPublica?: boolean) => {
      if (!perguntas) return;
      const _pergunta = Object.assign({}, changes);
      const isPerguntaAssociado =
        _pergunta?.usuarioDuvida.toLowerCase() === usuario?.nome.toLowerCase();
      const canBeListed = isPerguntaAssociado || flgPublica;
      const lista = Array.from(perguntas);
      const _index = lista.findIndex(
        (item) => item.idDuvidaFrequente === _pergunta.idDuvidaFrequente
      );
      if (_index >= 0) {
        !canBeListed && lista.splice(_index, 1);
        canBeListed && (lista[_index] = _pergunta);
      } else {
        canBeListed && lista.push(_pergunta);
      }

      action({
        type: 'setPerguntas',
        value: lista,
      });
    },
    [perguntas, usuario]
  );

  const isPerguntaAdmin = (pergunta: Pergunta) => {
    return pergunta.flgDestaque;
  };

  const isPerguntaUsuario = useCallback(
    (pergunta: Pergunta) => {
      if (isPerguntaAdmin(pergunta)) return false;
      return (
        pergunta?.usuarioDuvida.toLowerCase() === usuario?.nome.toLowerCase()
      );
    },
    [usuario]
  );

  const isPerguntaNaoLida = (pergunta: Pergunta) => {
    return pergunta.resposta !== null && !pergunta.lido;
  };

  const carregarPerguntas = useCallback(async () => {
    dispatch(
      assembleiaAssociadoActionsLoadDuvidas(
        idEventoReducer,
        usuario!.cpfCnpj,
        undefined,
        ErrorHandler
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEvent, usuario, dispatch]);

  const abrirModalContas = useCallback(() => {
    dispatch(
      openModal(SeletorContasParaVotoModal, {
        modalKey: selecaoContasModalKey,
        preventEscExit: true,
        preventMaskExit: false,
        mobileOnXS: false,
        title: translation.SeletorContasParaVotoModal.title,
        onClose: () => {
          dispatch(closeModal(selecaoContasModalKey));
        },
        onConfirm: () => {
          return new Promise<void>((resolve: any) => {
            resolve();
            dispatch(closeModal(selecaoContasModalKey));
          });
        },
      })
    );
    setFirstSelection(true);
  }, [dispatch]);

  const abrirModalContasConfirmadas = useCallback(() => {
    dispatch(
      openModal(ConfirmedPresenceNotOnline, {
        modalKey: selecaoContasModalKey,
        preventEscExit: true,
        preventMaskExit: false,
        mobileOnXS: false,
        onClose: () => closeModal(ContasConfirmadasModalKey),
      })
    );
  }, [dispatch]);

  const abrirModalMenorEmancipado = useCallback(() => {
    dispatch(
      openModal(UnanticipatedUser, {
        modalKey: selecaoContasModalKey,
        preventEscExit: true,
        preventMaskExit: false,
        mobileOnXS: false,
        onClose: () => closeModal(ContasConfirmadasModalKey),
      })
    );
  }, [dispatch]);

  const abrirDocumentos = useCallback(() => {
    const modalKey: string = getUniqueKey();
    dispatch(
      modalsActionsOpen(
        AssembleiaDocsModal,
        {
          genericProps: {
            key: modalKey,
          } as IAssembleiaDocsModalGenericProps,
        },
        modalKey
      )
    );
  }, [dispatch]);

  const abrirVideos = useCallback(() => {
    const modalKey: string = getUniqueKey();
    dispatch(
      modalsActionsOpen(
        AssembleiaVideosModal,
        {
          genericProps: {
            key: modalKey,
          } as IAssembleiaVideosModalGenericProps,
        },
        modalKey
      )
    );
  }, [dispatch]);

  const isConvocado = (contas: IAssembleiaContaAssociado[]) => {
    if (contas && contas.length > 0) {
      return contas.some((conta) => conta.idConvocado !== undefined);
    }
    return false;
  };

  const isColaborador = useMemo(() => {
    if (currentEvent?.contasDisponiveis && usuario) {
      const contasSelecionadas = currentEvent.contasDisponiveis.filter(
        (conta) => contaSelecionadaPeloUsuario(conta, usuario.cpfCnpj)
      );
      if (contasSelecionadas.length === 0) return false;
      const hasContaNaoColaborador = contasSelecionadas.some(
        (conta) => conta.flgColaborador !== FlagColaborador.Colaborador
      );
      return !hasContaNaoColaborador;
    }
    return false;
  }, [currentEvent, usuario]);

  const hasPermissionVideos = useMemo(() => {
    return usuario?.perfil.associadoRoute.assembleias.pre.videos.ver || false;
  }, [usuario]);

  const hasPermissionDocumentos = useMemo(() => {
    return (
      usuario?.perfil.associadoRoute.assembleias.pre.documentos.ver || false
    );
  }, [usuario]);

  const hasAccountsToVote = (contas: IAssembleiaContaAssociado[]) => {
    return contas.some((conta) => conta.tipoPresenca === null);
  };

  const somePresentialPresence = (contas: IAssembleiaContaAssociado[]) => {
    const constasNaoOnline = contas.filter(
      (conta) => conta.tipoPresenca !== null && conta.tipoPresenca !== 'ONLINE'
    );

    return constasNaoOnline.length === contas.length;
  };

  const hasPermissionParticipar = useCallback(
    (contas: IAssembleiaContaAssociado[]) => {
      if (somePresentialPresence(contas)) return false;
      return (
        (isConvocado(contas) &&
          usuario?.perfil.associadoRoute.assembleias.pautas.participar) ||
        false
      );
    },
    [usuario]
  );

  const hasPermissionVerPautas = useMemo(() => {
    return usuario?.perfil.associadoRoute.assembleias.pautas.ver || false;
  }, [usuario]);

  const hasPermissionDuvidas = useMemo(() => {
    return (
      usuario?.perfil.associadoRoute.assembleias.pre.duvidasSugestoes.ver ||
      usuario?.perfil.associadoRoute.assembleias.pre.duvidasSugestoes
        .participar ||
      false
    );
  }, [usuario]);

  const selecaoInicial = useCallback(
    (contas: IAssembleiaContaAssociado[]) => {
      if (!currentEvent || !usuario || !hasPermissionParticipar(contas)) return;
      const selecionadas = getTotalContasSelecionadasPeloUsuario(
        contas,
        usuario.cpfCnpj
      );
      const total = getTotalContasSelecionadasOuNaoPeloUsuario(
        contas,
        usuario.cpfCnpj
      );
      if (
        selecionadas !== total &&
        hasAccountsToVote(contas) &&
        currentEvent.status === AssembleiaStatus.Live
      ) {
        abrirModalContas();
      }
    },
    [currentEvent, usuario, hasPermissionParticipar, abrirModalContas]
  );

  const modalConfirmedPresenceNonOnline = useCallback(() => {
    if (currentEvent && currentEvent.status === AssembleiaStatus.Live) {
      abrirModalContasConfirmadas();
    }
  }, [currentEvent, abrirModalContasConfirmadas]);

  const carregarContas = useCallback(() => {
    if (!currentEvent?.id || !usuario?.cpfCnpj) return;
    dispatch(
      assembleiasAssociadoActionsLoadContas(
        currentEvent.id,
        usuario.cpfCnpj,
        (data) => {
          if (
            data.flagMenorSemEmancipado ||
            (data.flagMenorSemEmancipado && data.flagPresencaNaoOnline)
          ) {
            abrirModalMenorEmancipado();
          } else {
            if (data.flagPresencaNaoOnline) {
              modalConfirmedPresenceNonOnline();
            } else {
              selecaoInicial(data.contas);
            }
          }
        }
      )
    );
  }, [
    dispatch,
    currentEvent,
    usuario,
    selecaoInicial,
    modalConfirmedPresenceNonOnline,
    abrirModalMenorEmancipado,
  ]);

  const carregarPautas = useCallback(() => {
    if (!currentEvent?.id) return;
    dispatch(assembleiasAssociadoActionsLoadPautas(currentEvent.id));
  }, [dispatch, currentEvent]);

  const isSameEvent = useMemo(() => {
    return currentEvent?.id === parseInt(id);
  }, [id, currentEvent]);

  useEffect(() => {
    if (currentEvent!?.id !== idEventoReducer) {
      action({ type: 'setEvento', value: currentEvent?.id });
      if (idEventoReducer !== undefined && idEventoReducer !== 0) {
        carregarPerguntas();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEvent, idEventoReducer]);

  useEffect(() => {
    action({
      type: 'setPerguntas',
      value: duvidas,
    });
  }, [duvidas]);

  useEffect(() => {
    if (!assembleiasChanges[currentEvent!?.id]) return;
    const newMessage = assembleiasChanges[currentEvent!?.id].messenger;
    if (newMessage && newMessage !== null) {
      action({ type: 'setMessage', value: newMessage });
    }
  }, [assembleiasChanges, currentEvent]);

  useEffect(() => {
    if (message) {
      const _message = Object.assign({}, message);
      action({
        type: 'setMessage',
        value: null,
      });
      atualizarPergunta(
        {
          duvida: _message.duvida,
          idDuvidaFrequente: _message.idDuvidaFrequente,
          resposta: _message.resposta || null,
          usuarioDuvida: _message.nomePessoaComentario,
          dataDuvida: _message.dataPergunta,
          dataResposta: '',
          lido: false,
          flgDestaque: _message.flgDestaque,
        },
        _message.flgPublica
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message]);

  const loadEvento = useCallback(async () => {
    const idEvent = parseInt(id) || -1;

    try {
      const { fail } = await eventoAPI.loadGuest(idEvent);
      if (fail) throw fail;

      dispatch(
        assembleiaAssociadoActionsLoadEvent(
          idEvent,
          () => {
            setFirstSelection(false);
          },
          (err) => {
            throw err;
          }
        )
      );
    } catch (erro) {
      const error = erro as AxiosError<ErrorApi>;
      if (
        error.code === ApiErrors.EventoNaoEncontrado ||
        (error.status === 417 &&
          (error?.message === 'evento.notFound' ||
            error?.message === 'coop.notFound'))
      ) {
        showToast({
          pauseOnFocusLoss: true,
          theme: ToastTypes.Error,
          showStatusBar: true,
          timeout: 4000,
          label: languageValues.toasts.error.keyErrors(error.message),
        });
        history.replace(AssociadoRoutePath);
      }
    }
  }, [dispatch, history, id, showToast]);

  useEffect(() => {
    loadEvento();
  }, [loadEvento]);

  useEffect(() => {
    if (
      currentEvent?.needCheckVote &&
      currentEvent.tipo !== AssembleiaTipo.Nucleo &&
      currentEvent.tipo !== AssembleiaTipo.Reuniao &&
      currentEvent.modoEvento !== AssemblyModalities.OFFLINE
    ) {
      dispatch(
        assembleiasAssociadoActionsCheckVotePermission(
          currentEvent.id,
          (resp: any) => {
            dispatch({
              type: ASSEMBLEIAS_ASSOCIADO_UPDATE_VOTE_PERMISSION,
              payload: resp,
            });
            carregarPautas();
          },
          ErrorHandler
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEvent, dispatch]);

  useEffect(() => {
    if (!currentEvent) return;

    const shouldLoadContas =
      currentEvent.needLoadContas &&
      !loadingContas &&
      currentEvent.status >= AssembleiaStatus.Pre;

    const shouldLoadPautas =
      currentEvent.needLoadPautas &&
      !loadingPautas &&
      (currentEvent.modoEvento === AssemblyModalities.OFFLINE ||
        currentEvent.status >= AssembleiaStatus.Pre);

    if (shouldLoadContas) {
      carregarContas();
    }

    if (shouldLoadPautas) {
      carregarPautas();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEvent, loadingContas, loadingPautas]);

  useEffect(() => {
    if (
      !wsOpened &&
      currentEvent?.id &&
      isSameEvent &&
      usuario?.associadoAccessToken
    ) {
      dispatch(
        wsAssembleiasActionsOpen(
          usuario.associadoAccessToken,
          usuario.cpfCnpj!,
          currentEvent.id,
          false,
          currentEvent.status,
          (e) => {
            return console.log('ws open', e);
          },
          (err) => {
            return console.error('ws fail', err);
          },
          (e) => {
            return console.info('ws closed', e);
          }
        )
      );
    }
    return () => {
      if (window.location.pathname !== location.pathname) {
        dispatch(wsAssembleiasActionsClose());
      }
    };
  }, [currentEvent, usuario, wsOpened, isSameEvent, dispatch, location]);

  useEffect(() => {
    if (
      currentEvent &&
      (currentEvent.status >= AssembleiaStatus.Live ||
        (currentEvent.modoEvento ===
          AssemblyModalities.HIBRIDO_PRESENCIAL_DIGITAL &&
          currentEvent.status === 0)) &&
      isSameEvent
    ) {
      !firstSelection && carregarContas();
    }
    if (currentEvent?.status && currentEvent.status < AssembleiaStatus.Live) {
      setFirstSelection(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEvent?.status, firstSelection, isSameEvent]);

  if (
    !usuario?.perfil.associadoRoute.assembleias.pre.ver &&
    !usuario?.perfil.associadoRoute.assembleias.live.ver
  ) {
    return <UnauthorizedScreen />;
  }

  if (!currentEvent && loadingEvent) {
    return <Loading text={''} />;
  }

  if (currentEvent?.id) {
    return (
      <Context.Provider
        value={{
          perguntas,
          atualizarPergunta,
          isPerguntaAdmin,
          isPerguntaUsuario,
          isPerguntaNaoLida,
          usuario,
          currentEvent,
          loadingEvent,
          loadingPautas,
          hasPermissionVideos,
          hasPermissionDocumentos,
          hasPermissionDuvidas,
          hasPermissionParticipar,
          hasPermissionVerPautas,
          abrirModalContas,
          abrirModalContasConfirmadas,
          abrirModalMenorEmancipado,
          abrirDocumentos,
          abrirVideos,
          isColaborador,
          isConvocado,
        }}
      >
        <Row id={'root-container-custom'} style={{ overflow: 'overlay' }}>
          <div className={style.container}>
            {permissionPre && <PreAssembleia />}
            {permissionLive && <Assembleia />}
            {permissionPre || permissionLive ? <Pautas /> : undefined}
          </div>
        </Row>
        {loadingEvent && (
          <Loading text='Aguarde, seu evento está sendo carregado' />
        )}
      </Context.Provider>
    );
  }

  return null;
}
